export default __webpack_public_path__ + "static/media/src_convert7776_mobile_5.36114e38.jpg";